import { useTranslation } from "react-i18next";
import { stdObject } from "../../data/types/stdObject";
import { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CircleIcon from "@mui/icons-material/Circle";
import convertDate from "../../utils/convertDate";
import { colors } from "../../data/colors";
import { getPrefix } from "../../utils/getPrefix";
import { recordsShowCodes } from "../../data/main";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { toPrice } from "../../utils/toPrice";

const IconType = ({ type = 0 }: stdObject) => {
  let Icon,
    color = colors.green;
  switch (type) {
    case 1:
      Icon = AddCircleIcon;
      break;
    case 2:
      Icon = RemoveCircleIcon;
      break;
    default:
      Icon = CircleIcon;
      color = colors.grey;
      break;
  }
  return (
    <span style={{ marginTop: 2 }}>
      <Icon style={{ fontSize: 16, color }} />
    </span>
  );
};

const getLabel = (label: string, t: any) => {
  if (!Number.isNaN(Number(label))) {
    return label;
  } else {
    switch (label) {
      case "suc":
        return t(`c.${label.toUpperCase()}`);
      case "userName":
        return t(`p.user`);
      case "insert":
        return t(`p.added`);
      case "hours":
        return t(`p.time`);
      case "shift":
        return t(`c.SCH`);
      default:
        if (recordsShowCodes.some((ext: string) => label.endsWith(ext))) {
          return t(`c.${getPrefix(label)}`);
        }
        return t(`p.${label}`);
    }
  }
};

const getValue = (label: string, value: string, params: stdObject) => {
  const { t, vPayments } = params;
  switch (label) {
    case "action":
      return value.toLowerCase();
    case "observ":
      return t(`r.${value}`).toLowerCase();
    case "CANDIN":
      return toPrice(value);
    case "TIPDIN":
      return (
        vPayments.find((e: stdObject) => e.CODTPA === Number(value))?.NOMTPA ??
        value
      );
    case "FECDIN":
    case "date":
      return convertDate({ info: value, t });
    case "type":
      return t(`c.${value.toUpperCase()}`);
    case "typeName":
      return t(value).toLowerCase();
    default:
      return value;
  }
};

const TreeNode = ({ label, init, value, parent }: stdObject) => {
  const { t } = useTranslation();
  const vPayments: any = useSelector((state: RootState) => state.data.vtpa);

  const [isOpen, setIsOpen] = useState(false);
  const isObject = value !== null && typeof value === "object";
  const toggleOpen = () => setIsOpen(!isOpen);

  if (!isObject) {
    return (
      <div style={{ paddingLeft: parent === "root" ? 0 : 10, margin: "4px 0" }}>
        <IconType />
        <strong style={{ marginLeft: 5 }}>{`${getLabel(label, t)}: `}</strong>
        {getValue(label, String(value), { t, vPayments })}
      </div>
    );
  }
  const buttonActive =
    (Array.isArray(value) && value.length > 0) || !Array.isArray(value);

  return (
    <div
      style={{
        paddingLeft: init || parent === "root" ? 0 : 10,
        margin: init ? 0 : "4px 0",
      }}
    >
      {!init && (
        <div
          onClick={buttonActive ? toggleOpen : () => {}}
          style={{
            cursor: "pointer",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
          }}
        >
          {!init && <IconType type={buttonActive ? (isOpen ? 2 : 1) : 0} />}
          <span style={{ marginLeft: init ? 0 : 5 }}>{getLabel(label, t)}</span>
        </div>
      )}

      {(isOpen || init) && (
        <div
          style={{
            borderLeft: init ? "none" : `1px dashed ${colors.grey}`,
            marginLeft: init ? 0 : 8,
          }}
        >
          {Object.entries(value)
            .filter(
              ([key]) =>
                (!init && !["COBDIN"].includes(key)) ||
                (init && !["typeName", "observ", "userCode"].includes(key)),
            )
            .map(([key, val]) => {
              if (
                ["insert", "update", "delete", "staff"].includes(label) &&
                Array.isArray(val)
              ) {
                val = Object.fromEntries(val);
              }
              return (
                <TreeNode key={key} label={key} value={val} parent={label} />
              );
            })}
        </div>
      )}
    </div>
  );
};

export default function JSONBox({ data }: stdObject) {
  return (
    <div style={{ height: 300, width: 350, overflow: "auto" }}>
      <TreeNode label="root" init={true} value={data} />
    </div>
  );
}
